(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["np-menu-v3"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('np-menu')) {
      customElements.define('np-menu', class extends HTMLElement {
        connectedCallback() {
          // The sticky header changes height and moves as it settles, so an open panel re-aligns to its bottom edge every frame.
          const row = this.closest('[ref="headerRowTop"]') || document.getElementById('header-component') || this;
          let raf = 0;
          const follow = () => {
            const dd = this.querySelector('.npm-d__dd button[aria-expanded="true"]')?.parentElement;
            if (!dd) return (raf = 0);
            const panel = dd.querySelector('.npm-d__panel');
            // Correct by the measured difference: the header's transform makes 'fixed' relative to the header, not the window.
            const pr = panel.getBoundingClientRect();
            panel.style.top = (parseFloat(panel.style.top) || 0) + row.getBoundingClientRect().bottom - pr.top + 'px';
            if (panel.classList.contains('npm-d__panel--help'))
              panel.style.left = (parseFloat(panel.style.left) || 0) + dd.getBoundingClientRect().left - 20 - pr.left + 'px';
            raf = requestAnimationFrame(follow);
          };
          const close = (dd) => { dd.querySelector('button').setAttribute('aria-expanded', 'false'); dd.querySelector('.npm-d__panel').hidden = true; };
          const open = (dd) => {
            this.querySelectorAll('.npm-d__dd').forEach((o) => o !== dd && close(o));
            dd.querySelector('button').setAttribute('aria-expanded', 'true');
            dd.querySelector('.npm-d__panel').hidden = false;
            cancelAnimationFrame(raf);
            follow();
          };
          this.querySelectorAll('.npm-d__dd').forEach((dd) => {
            let t;
            dd.addEventListener('pointerenter', (e) => { if (e.pointerType !== 'mouse') return; clearTimeout(t); open(dd); });   // instant (Ollie: hover felt slow)
            dd.addEventListener('pointerleave', (e) => { if (e.pointerType !== 'mouse') return; clearTimeout(t); t = setTimeout(() => close(dd), 200); });
            dd.querySelector('button').addEventListener('click', () => (dd.querySelector('.npm-d__panel').hidden ? open(dd) : close(dd)));
          });
          document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.querySelectorAll('.npm-d__dd').forEach(close); });
          document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.querySelectorAll('.npm-d__dd').forEach(close); });
        }
      });
    }
    if (!customElements.get('np-menu-tabs')) {
      customElements.define('np-menu-tabs', class extends HTMLElement {
        connectedCallback() {
          this.querySelectorAll('[data-tab]').forEach((tab) => tab.addEventListener('click', () => {
            this.querySelectorAll('[data-tab]').forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
            this.querySelectorAll('[data-pane]').forEach((p) => { p.hidden = p.dataset.pane !== tab.dataset.tab; });
            this.closest('.menu-drawer')?.scrollTo(0, 0);
          }));
          this.querySelector('[data-close]')?.addEventListener('click', () => this.closest('header-drawer')?.close());
        }
      });
    }
  } catch(e) { console.error(e); }
})();

})();
